import React from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import * as styles from './nav.module.css'
import MobileMenu from './MobileMenu'
import ThemeLogo from '../themeLogo'
import Button from '../button'
import { getLinkPath } from '../../helpers'

// @todo what is this nonsense even doing?
// @url https://www.gatsbyjs.com/docs/reference/built-in-components/gatsby-link/#show-active-styles-for-partially-matched-and-parent-links
const isPartiallyActive = ({ isPartiallyCurrent }) => {
  return isPartiallyCurrent ? { className: styles.active } : null
}

const Navigation = () => {
  const data = useStaticQuery(graphql`
    {
      headerNavMenu: contentfulNavMenu(key: { eq: "nav.header" }) {
        ...navMenuFields
      }
      homePage: contentfulPage(name: { eq: "page.home" }) {
        homePageSlug: slug
      }
    }
  `)
  const { links, ctaLink } = data.headerNavMenu
  const { homePageSlug } = data.homePage

  return (
    // desktop menu
    <div className={styles.navWrapper}>
      <div className={styles.nav}>
        <Link to={homePageSlug}>
          <ThemeLogo />
        </Link>
        <div className={styles.navLinks}>
          {links.map(link => (
            <Link
              key={link.title}
              getProps={isPartiallyActive}
              to={getLinkPath(link)}
            >
              {link.title}
            </Link>
          ))}

          {ctaLink && (
            <Link getProps={isPartiallyActive} to={getLinkPath(ctaLink)}>
              <Button action="primary">{ctaLink.title}</Button>
            </Link>
          )}
        </div>
      </div>

      {/* mobile menu  */}
      <MobileMenu
        isPartiallyActive={isPartiallyActive}
        homePageSlug={homePageSlug}
        links={links}
        ctaLink={ctaLink}
      />
    </div>
  )
}

export default Navigation
